
import { Component, Mixins } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules/index";
import mixin from "./mixin";
import * as modals from "../../../lib/modals";
import { formatDateWithTime } from "../../../utils";
import notifications from "../../../lib/notifications";

const orderModule = getModule(OrderModule);

@Component({
  name: modals.orderAuditTrailModal
})
export default class OrderAuditTrailModal extends Mixins(mixin) {
  integrationLogs: any = null;
  visionOpsLogs: any = null;
  expediteLogs: any = null;
  eventTypes: Array<any> = [];
  loading: boolean = false;
  sortDateDesc: boolean = false;

  get orderNumber() {
    return this.selectedItems[0].number;
  }

  get expediteLogRows() {
    const selectedEventTypes = this.eventTypes.filter(x => x.selected).map(x => x.name);
    if (selectedEventTypes?.length < 1) return this.expediteLogs;
    return this.expediteLogs.filter(x => selectedEventTypes.indexOf(x.activity) > -1);
  }

  formatDate(date) {
    return formatDateWithTime(date);
  }

  toggleSort() {
    this.sortDateDesc = !this.sortDateDesc
    this.expediteLogs = this.expediteLogs.sort((a,b) => this.sortDateDesc ? new Date(b.updatedDate).getTime() - new Date(a.updatedDate).getTime() : new Date(a.updatedDate).getTime() - new Date(b.updatedDate).getTime());
    this.visionOpsLogs = this.visionOpsLogs.sort((a,b) => this.sortDateDesc ? new Date(b.logDate).getTime() - new Date(a.logDate).getTime() : new Date(a.logDate).getTime() - new Date(b.logDate).getTime());
    this.integrationLogs = this.integrationLogs.sort((a,b) => this.sortDateDesc ? new Date(b.logDate).getTime() - new Date(a.logDate).getTime() : new Date(a.logDate).getTime() - new Date(b.logDate).getTime());  
  }

  getIcon(requestType: any) {
    var result = "fa fa-file";   
    if(requestType == "CancelOrder") result = "fa fa-ban";
    if(requestType == "Callback") result = "fa fa-comment";
    if(requestType == "UpdateOrder") result = "fa fa-check-circle";
    return result;
  }

  copyText(textToCopy: string) {
    navigator.clipboard.writeText(textToCopy);
    notifications.success("Copied", "Text copied to your clipboard.");
  }

  async load() {
    this.show();
    this.loading = true;

    try {
      const response = await orderModule.getVisionOpsLogsForOrder(this.orderNumber);
      this.visionOpsLogs = response.data;
    } catch (ex) {
      notifications.error("Vision Ops Logs", "Failed to load Vision Ops logs for order.", ex);
    }

    try {
      const response = await orderModule.getExpediteAuditLogsForOrder(this.orderNumber);
      this.expediteLogs = response.data;
      this.expediteLogs.forEach(item => {
        let existingType = this.eventTypes.find(x => x.name == item.activity);
        if (!existingType) {
          existingType = { name: item.activity, count: 0, selected: false };
          this.eventTypes.push(existingType);
        }
        existingType.count += 1;
      });
    } catch (ex) {
      notifications.error("Expedite Audit Logs", "Failed to load expedite audit logs", ex);
    }

    try {
      const response = await orderModule.getIntegrationLogsForOrder(this.orderNumber);
      this.integrationLogs = response.data;
    } catch (ex) {
      notifications.error("Integration Ops Logs", "Failed to load integration logs for order.", ex);
    }

    this.loading = false;
  }

  selectEventType(eventType) {
    eventType.selected = !eventType.selected;
  }

  reset() {
    this.eventTypes = [];
  }
}
